import {
	MAX_PLAYER_EAT_HOTDOG_TIME,
	MAX_PLAYER_SPEED,
	MAX_PLAYER_SPEED_CHANGE_INTERVAL,
	MIN_PLAYER_EAT_HOTDOG_TIME,
	MIN_PLAYER_SPEED,
	MIN_PLAYER_SPEED_CHANGE_INTERVAL,
} from "../config"

export const randomRange = (min: number, max: number) => Math.random() * (max - min) + min
export const randomSpeed = () => randomRange(MIN_PLAYER_SPEED, MAX_PLAYER_SPEED)
export const randomChangeInterval = () =>
	randomRange(MIN_PLAYER_SPEED_CHANGE_INTERVAL, MAX_PLAYER_SPEED_CHANGE_INTERVAL)
export const randomHotdogTime = () => randomRange(MIN_PLAYER_EAT_HOTDOG_TIME, MAX_PLAYER_EAT_HOTDOG_TIME)
